import axios from "axios";

export default {
    changeGalateaAdminRole(roleId, admin) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role/" + roleId + "/changeGalateaAdminRole/" + admin,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    update(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllWithoutPagination() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/roles",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/roles?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllWithOutPermissions(currentPage = 0, pageSize = 10) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/roles/withOutPermissions?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPermissions() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role/permissions",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPending() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/roles/pending",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    delete() {
        return axios({
            method: "delete",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/role/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
